/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type STORY_MODE = "COMMENTS" | "QA" | "RATINGS_AND_REVIEWS" | "%future added value";
export type StreamContainer_story = {
    readonly id: string;
    readonly url: string;
    readonly isClosed: boolean;
    readonly settings: {
        readonly mode: STORY_MODE;
    };
    readonly commentCounts: {
        readonly totalPublished: number;
        readonly tags: {
            readonly FEATURED: number;
            readonly UNANSWERED: number;
            readonly REVIEW: number;
            readonly QUESTION: number;
        };
    };
    readonly isArchived: boolean;
    readonly isArchiving: boolean;
    readonly " $fragmentRefs": FragmentRefs<"CreateCommentMutation_story" | "CreateCommentReplyMutation_story" | "ModerateStreamContainer_story" | "PostCommentFormContainer_story" | "PreviousCountSpyContainer_story" | "StoryClosedTimeoutContainer_story" | "StoryRatingContainer_story" | "ViewersWatchingContainer_story">;
    readonly " $refType": "StreamContainer_story";
};
export type StreamContainer_story$data = StreamContainer_story;
export type StreamContainer_story$key = {
    readonly " $data"?: StreamContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"StreamContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StreamContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isClosed",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "StorySettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mode",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "CommentCounts",
            "kind": "LinkedField",
            "name": "commentCounts",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalPublished",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "CommentTagCounts",
                    "kind": "LinkedField",
                    "name": "tags",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "FEATURED",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "UNANSWERED",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "REVIEW",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "QUESTION",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isArchived",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isArchiving",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreateCommentMutation_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreateCommentReplyMutation_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ModerateStreamContainer_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PostCommentFormContainer_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PreviousCountSpyContainer_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StoryClosedTimeoutContainer_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StoryRatingContainer_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ViewersWatchingContainer_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = 'cbf09f14fdf40e190a794cca165992ad';
export default node;
